import { render, staticRenderFns } from "./OlympiadNotificationBanner.vue?vue&type=template&id=56b53b85&scoped=true&lang=pug&"
import script from "./OlympiadNotificationBanner.vue?vue&type=script&lang=js&"
export * from "./OlympiadNotificationBanner.vue?vue&type=script&lang=js&"
import style0 from "./OlympiadNotificationBanner.vue?vue&type=style&index=0&id=56b53b85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b53b85",
  null
  
)

export default component.exports